module.exports = __webpack_public_path__ + "img/hr-pump-south-liquid.5619d75f.png";